import { atom, useAtom } from "@libraries/jotai";

import { CustomerTheme } from "./themes";
import lightTheme from "./themes/light";

const themeAtom = atom<CustomerTheme>(lightTheme);

export default function useTheme() {
  const [theme, setTheme] = useAtom(themeAtom);

  return { theme, setTheme };
}
